import { VideoUIChat } from "./VideoUIChat";
import { useChatVisibility } from "@platform/hooks/useChatVisibility";
import { usePlatformStore } from "@platform/store";

export function VideoUIChatContainer() {
  const userCircles = usePlatformStore((s) => s.userCircles);
  const { shouldShowChat, isLoading } = useChatVisibility({ userCircles });

  // Don't render chat if disabled or still loading
  if (isLoading || !shouldShowChat) {
    return null;
  }

  return <VideoUIChat />;
}

export default VideoUIChatContainer;
